import { useCallback, useEffect, useState } from 'react';
import { Node } from '@tiptap/pm/model';

export function useDeleteEmptyDBlockOnMainInput(deleteNode: () => void, node: Node) {
  const [isEmptyBlock, setIsEmptyBlock] = useState(false);

  const mainInputElementId = 'flow-editor-message-input';

  /**
   * Function to handle block deletion
   */
  const handleDeleteBlock = () => {
    deleteNode();
    // Focuses on the input field
    document.getElementById(mainInputElementId)?.focus();
  };

  /**
   * Callback function to handle user key press events
   */
  const handleUserKeyPress = useCallback(
    (event: KeyboardEvent) => {
      const { key } = event;

      if (
        key &&
        event.target instanceof HTMLInputElement &&
        event.target.id === mainInputElementId
      ) {
        if (isEmptyBlock) {
          // Triggers block deletion
          handleDeleteBlock();
        }
      }
    },
    [isEmptyBlock],
  );

  // Sets up an event listener for keydown events when the component mounts
  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);

    // Cleans up the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [handleUserKeyPress]);

  // Checks if the content of a block is empty
  useEffect(() => {
    if (node.textContent.length < 1 && !node.firstChild) {
      setIsEmptyBlock(true);
    } else {
      setIsEmptyBlock(false);
    }
  }, [node.textContent]);
}
